import styled from "styled-components";

const StyledVideo = styled.figure`
  background-image: url(${(props) => props.thumbnail});
`;

export default StyledVideo;
